import { useMutation } from "@tanstack/react-query"

import type { UpdateWorkflowChatRequest, WorkflowItem } from "@/api/models"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

export function updateWorkflowChatHistoryApi(
  workflowId: string,
  data: UpdateWorkflowChatRequest
): Promise<WorkflowItem> {
  return api.patch(`/explorer/workflow/${workflowId}/chat`, data)
}

export function useUpdateWorkflowChatHistory(workflowId: string) {
  return useMutation({
    mutationKey: queryKeys.updateWorkflowChat(workflowId),
    mutationFn: (data: UpdateWorkflowChatRequest) => updateWorkflowChatHistoryApi(workflowId, data),
  })
}
